module.exports = __webpack_public_path__ + "img/b4.1ef62f11.png";